// extracted by mini-css-extract-plugin
export default {"wrapper":"Source-module__wrapper--de626","icon":"Source-module__icon--cebe5","disabled":"Source-module__disabled--eb551"};